import {
  APPOINTMENT_STATUS_CONFIRMED,
  APPOINTMENT_STATUS_UNCONFIRMED
} from "constants/appointments";
import { isInThePast, isWithin24Hours } from "utils/common";

export const resolveDraftConfirmationStatus = (
  appointmentStart: string | undefined
): number =>
  appointmentStart &&
  (isWithin24Hours(appointmentStart) || isInThePast(appointmentStart))
    ? APPOINTMENT_STATUS_CONFIRMED
    : APPOINTMENT_STATUS_UNCONFIRMED;
